import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_LEAD_PRICES,

} from "./actionTypes"

import {
  getLeadPricesSuccess,
  getLeadPricesError,

} from "./actions"

import {

  genericGetRequest,
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"

function* onGetLeadPrices(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_prices`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getLeadPricesSuccess(response))
  } catch (error) {
    yield put(getLeadPricesError(error))
  }
}


function* LeadPricesSaga() {
  yield takeEvery(GET_LEAD_PRICES, onGetLeadPrices)


}

export default LeadPricesSaga

